import { EventMeta } from '../../../interfaces/meta.interface';

const folderBind: EventMeta = {
    title: 'Mailbox Folder Accessed',
    default: {
        description: 'Mailbox Folder Accessed',
        longDescription: 'A mailbox folder was accessed.',
        severity: 'info',
    },
};

export default folderBind;
